import React, { Component } from "react";
import { Checkbox } from "material-ui";
import ValuePanel from "./ValuePanel";

import map from "lodash/map";
import find from "lodash/find";
import some from "lodash/some";
import filter from "lodash/filter";

class RegionLocalePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      indexKey: null,
      selectedVal: null,
      selectedStates: [],
    };
  }

  componentWillUnmount() {
    this.setState({
      indexKey: null,
      selectedVal: null,
      selectedStates: [],
    });
  }

  handleLocaleSelect(id, isChecked) {
    const locale = find(this.props.locales, (m) => {
      return m.id === id;
    });
    this.props.selectLocale(locale, isChecked);
  }
  render() {
    let displayLocales;
    if (this.state.indexKey) {
      const regionName = this.state.selectedVal;
      displayLocales = filter(this.props.locales, (m) => {
        return m.value.split(" - ")[0] === regionName;
      });
    }
    const selectedRegionIds = map(this.props.selected_region, "id");
    return (
      <div style={{ display: "flex", flexGrow: "1" }}>
        <div
          key={"geo-state-node-contianer"}
          style={{ width: "300px" }}
          className="light-grey-border"
        >
          <div
            className="pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <strong>Region</strong>
            </div>
            <div style={{ height: "24px" }}></div>
          </div>
          <div
            style={{
              height: "453px",
              overflowY: "scroll",
            }}
          >
            {map(this.props.regions, (data) => {
              let clsName = " ml-10 mr-10";
              const showMark = some(this.props.selected_locale, (m) => {
                return m.value.split(" - ")[0] === data.value;
              });
              return (
                <div
                  key={data.label + "_" + data.id}
                  style={{
                    color: "#017FB5",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  className={clsName}
                  onClick={() => {
                    this.setState({
                      indexKey: data.id,
                      selectedVal: data.value,
                    });
                    //if (this.props.getCities) this.props.getCities(data.id);
                  }}
                >
                  <div
                    className="p-10 mr-10"
                    style={{
                      background:
                        this.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
                      flexGrow: "1",
                      display: "flex",
                    }}
                  >
                    <Checkbox
                      label={""}
                      labelStyle={{ fontSize: "16px" }}
                      style={{ width: "10px" }}
                      iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                      checked={selectedRegionIds.indexOf(data.id) >= 0}
                      onCheck={(e, isInputChecked) => {
                        this.props.selectRegion(data, isInputChecked);
                      }}
                    />
                    <div style={{ flexGrow: "1" }}>{data.label}</div>
                    <div
                      style={{
                        display:
                          showMark && selectedRegionIds.indexOf(data.id) < 0
                            ? "flex"
                            : "none",
                        paddingTop: "4px",
                      }}
                    >
                      <i className="icon-checkmark4 text-orange-400" />
                    </div>
                  </div>
                  <div className="tree-node-arrow-right"></div>
                </div>
              );
            })}
          </div>
        </div>
        {displayLocales && (
          <div style={{ flexGrow: "1" }}>
            <ValuePanel
              key={this.state.selectedVal + "_values_panel"}
              displayData={displayLocales}
              selected_segments={map(this.props.selected_locale, "id")}
              title={"Locale"}
              showFilter={true}
              onCheck={(id, isChecked) => {
                this.handleLocaleSelect(id, isChecked);
              }}
              disabledAll={selectedRegionIds.indexOf(this.state.indexKey) >= 0}
              granularity={this.props.granularity}
            />
          </div>
        )}
      </div>
    );
  }
}

export default RegionLocalePanel;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/RegionLocalePanel.js